<template>
    <div class="text-xs-center">
        <v-dialog v-model="dialog" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text
                    >Загрузка данных...
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'preloader',

    data() {
        return {
            dialog: this.$store.state.preloader,
        };
    },

    watch: {
        dialog(val) {
            console.log('val', val);
            if (!val) return;

            // setTimeout(() => (this.dialog = false), 4000);
        },
    },
};
</script>
